export const NAME = 'page'
export const SET_CONTENT = 'SET_CONTENT'
export const SET_LOAD = 'SET_LOAD'
export const CLEAR = 'CLEAR_PAGE'